import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiX, FiCheck } from "react-icons/fi";
import { useAllCategoriesQuery } from "../../store/services/homeProducts";

const commonSizes = ["Free", "35", "36", "37", "38", "39", "40", "41", "42"];

const toFaText = (value = "") =>
  String(value ?? "").replace(/[0-9]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);

const toggleValue = (list, value) => {
  const cleanValue = String(value || "").trim();

  if (!cleanValue) return list;

  if (list.includes(cleanValue)) {
    return list.filter((item) => item !== cleanValue);
  }

  return [...list, cleanValue];
};

const SizeFinderQuick = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { data } = useAllCategoriesQuery();
  const categories = data?.categories || [];

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);

  if (!open) return null;

  const submit = (event) => {
    event.preventDefault();

    if (!selectedSizes.length) return;

    const params = new URLSearchParams();

    if (selectedCategories.length) {
      params.set("category", selectedCategories.join(","));
    }

    params.set("size", selectedSizes.join(","));

    onClose?.();
    navigate(`/size-finder?${params.toString()}`);
  };

  const clearAll = () => {
    setSelectedCategories([]);
    setSelectedSizes([]);
  };

  const selectedCategoryLabels = selectedCategories
    .map((value) => {
      const found = categories.find((item) => String(item.slug || item.name || item.id) === value);
      return found?.name || value;
    })
    .filter(Boolean);

  return (
    <div className="size-popup-backdrop" onClick={onClose}>
      <div className="size-popup-card" onClick={(event) => event.stopPropagation()}>
        <div className="size-popup-drag" />

        <button type="button" className="size-popup-close" onClick={onClose} aria-label="بستن">
          <FiX size={19} />
        </button>

        <div className="size-popup-head">
          <span>سایز من</span>
          <h2>انتخاب سریع کفش</h2>
          <p>سایزت را انتخاب کن تا محصولات مناسب را ببینی.</p>
        </div>

        <form className="size-popup-modern-form" onSubmit={submit}>
          <div className="size-choice-block">
            <div className="size-choice-row-title">
              <div className="size-choice-title">دسته‌بندی</div>
              {selectedCategories.length > 0 && (
                <button type="button" onClick={() => setSelectedCategories([])}>
                  همه
                </button>
              )}
            </div>

            <div className="size-category-chips">
              <button
                type="button"
                className={!selectedCategories.length ? "active" : ""}
                onClick={() => setSelectedCategories([])}
              >
                همه
              </button>

              {categories.map((item) => {
                const value = String(item.slug || item.name || item.id);
                const active = selectedCategories.includes(value);

                return (
                  <button
                    type="button"
                    className={active ? "active" : ""}
                    onClick={() => setSelectedCategories((prev) => toggleValue(prev, value))}
                    key={item.id || item._id || value}
                  >
                    {active && <FiCheck size={14} />}
                    {item.name}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="size-choice-block size-choice-block-important">
            <div className="size-choice-row-title">
              <div className="size-choice-title">سایز کفش</div>
              {selectedSizes.length > 0 && (
                <button type="button" onClick={() => setSelectedSizes([])}>
                  پاک کردن
                </button>
              )}
            </div>

            <div className="size-grid-options">
              {commonSizes.map((item) => {
                const active = selectedSizes.includes(item);

                return (
                  <button
                    type="button"
                    className={active ? "active" : ""}
                    onClick={() => setSelectedSizes((prev) => toggleValue(prev, item))}
                    key={item}
                    aria-pressed={active}
                  >
                    {active && <FiCheck size={15} />}
                    <span>{item === "Free" ? "Free" : toFaText(item)}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className={`size-popup-selected-line ${(selectedCategories.length || selectedSizes.length) ? "active" : ""}`}>
            {selectedSizes.length > 0 ? (
              <div className="size-popup-selected-values">
                <strong>سایز انتخاب‌شده:</strong>
                <span>{selectedSizes.map((item) => (item === "Free" ? "Free" : toFaText(item))).join("، ")}</span>
              </div>
            ) : (
              <div className="size-popup-selected-values muted">
                <strong>هنوز سایزی انتخاب نشده</strong>
                <span>برای نمایش محصولات، حداقل یک سایز انتخاب کن.</span>
              </div>
            )}

            {selectedCategoryLabels.length > 0 && (
              <div className="size-popup-selected-values">
                <strong>دسته:</strong>
                <span>{selectedCategoryLabels.join("، ")}</span>
              </div>
            )}

            {(selectedCategories.length > 0 || selectedSizes.length > 0) && (
              <button type="button" onClick={clearAll}>
                حذف انتخاب‌ها
              </button>
            )}
          </div>

          <button type="submit" className="size-popup-submit" disabled={!selectedSizes.length}>
            <FiSearch size={18} />
            <span>{selectedSizes.length ? "نمایش محصولات مناسب" : "اول سایز را انتخاب کن"}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default SizeFinderQuick;
